/*********************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                  part without express written permission of Honeywell Inc.
 *                  is prohibited.
 *
 * Name          : DisplayPurchaseTypeCard.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Sep 29, 2020
 *
 * @Version      : Version 1.0
 *
 * By             : H422337
 * On             : Sep 29,2020
 * Description    : ASDS-3257 APU enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 29,2020
 * Description    : ASDS-3256 APU enhancements as part of phase-2
 *
 **********************************************************************************/
import * as React from 'react';
import { Grid, Icon, Card } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';

function DisplayPurchaseTypeCard(props) {
 return(
    <Card className="fullwidthCard config-confirmation-card-spacing">
    <Card.Content>
        <Grid>
            <Grid.Row>
                <Grid.Column width={11} className="fullwidthRow">
                    <span className="confirmation-title-text">KEY PURCHASE TYPE</span>
                </Grid.Column>
                <Grid.Column width={1} className="fullwidthRow">
                    <div className="pull-right">
                        <Icon
                            root="common"
                            name="edit"
                            size="small"
                            className="confirmation-edit-icon"
                            onClick={props.gotoProductPurchaseTab}
                        />
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
        <Grid>
            <Grid.Row>
                <Grid.Column width={12} className="custType">
                    <p className="confirmation-sub-text">{props.purchaseTypeSubText}</p>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Card.Content>
</Card>

 );

}

export default DisplayPurchaseTypeCard;